import React from 'react';

interface IEvePriceCalculatorCheckboxProps {
    label: string;
    checkboxName: string;
    value: boolean;
    onChange: (name: string, value: string) => void;
}

export const EvePriceCalculatorCheckbox: React.FC<IEvePriceCalculatorCheckboxProps> = props => {
    const { label, checkboxName, value, onChange } = props;
    const className = `eve-price-calculator-display__form-row-${checkboxName}`;

    /**
     * Emits checkbox toggle change
     * @param e Event
     */
    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>): void => onChange(e.target.name, e.target.value);

    return (
        <div className={`${className}`}>
            <label className={`${className}--label`} htmlFor={checkboxName}>
                {label}
            </label>
            <input
                className={`${className}--checkbox`}
                type='checkbox'
                id={checkboxName}
                name={checkboxName}
                checked={value}
                onChange={handleOnChange}
            />
        </div>
    );
};
